import { createFileRoute, linkOptions } from '@tanstack/react-router'
import type { CoverageResponse } from 'types'

import CoverageSheetContent from '@/components/sheets/coverage/coverage-sheet-content'
import { coverageSheetPreload } from '@/components/sheets/coverage/coverage-sheet-preload'

export const Route = createFileRoute(
  '/app/data/companies/$uuid/(mainPage)/debtor/coverages/$coverageUuid/',
)({
  component: RouteComponent,
  loader: ({ params, context: { queryClient } }) =>
    coverageSheetPreload(params.coverageUuid, queryClient),
})

const coverageRowLink = (coverage: CoverageResponse) =>
  linkOptions({
    from: Route.fullPath,
    to: '.',
    params: { coverageUuid: coverage.uuid },
  })

function RouteComponent() {
  const { coverageUuid } = Route.useParams()

  return (
    <CoverageSheetContent
      coverageUuid={coverageUuid}
      coverageRowLink={coverageRowLink}
    />
  )
}
